import { useMemo, useState } from 'react';
import { BanknotesIcon, PresentationChartLineIcon, Squares2X2Icon, ChartBarSquareIcon } from '@heroicons/react/24/solid';
import ManagerNav from './managernav';
import ClockInData from './ClockinData';
import StaffCosts from './staffcosts';
import ProjectFinancials from './projectfinancials';

const FINANCE_TABS = [
  {
    key: 'clock',
    label: 'Payroll & Clock-ins',
    description: 'Live labour cost, payroll cut-offs, and Sage export tools.',
    icon: BanknotesIcon,
    component: <ClockInData showNav={false} />
  },
  {
    key: 'staff-costs',
    label: 'Staff Costs',
    description: 'Budgets vs actuals by department, hiring needs, and vacancy tracking.',
    icon: Squares2X2Icon,
    component: <StaffCosts />
  },
  {
    key: 'projects',
    label: 'Project Financials',
    description: 'Project profitability, revenue pacing, and materials spend.',
    icon: PresentationChartLineIcon,
    component: <ProjectFinancials />
  },

];

export default function Finances() {
  const [activeTab, setActiveTab] = useState(FINANCE_TABS[0].key);
  const tabConfig = useMemo(() => FINANCE_TABS.find((tab) => tab.key === activeTab) ?? FINANCE_TABS[0], [activeTab]);

  return (
    <>
      <ManagerNav />
      <div
        className="min-h-screen bg-white bg-cover bg-top pb-16"
        style={{ backgroundImage: 'url(/background.png)' }}
      >
        <div className="mx-auto w-full max-w-6xl px-4 pt-10 sm:px-6 lg:px-8">
          <div className="rounded-3xl border border-indigo-100 bg-white/95 p-8 shadow-2xl backdrop-blur">
            <p className="text-sm font-semibold uppercase tracking-[0.25em] text-indigo-500">Financial Control</p>
            <h1 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">Finances built for workforce-heavy teams.</h1>
            <p className="mt-4 text-base text-slate-600 sm:text-lg">
              Switch between payroll, staffing budgets, and project profitability without leaving one workspace.
            </p>
            <div className="mt-8 flex flex-col gap-3 overflow-x-auto pb-2 sm:flex-row">
              {FINANCE_TABS.map((tab) => {
                const isActive = tab.key === tabConfig.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setActiveTab(tab.key)}
                    className={`flex flex-1 min-w-[220px] items-center gap-3 rounded-2xl border px-4 py-3 text-left transition ${
                      isActive
                        ? 'border-transparent bg-gradient-to-r from-purple-600 to-blue-500 text-white shadow-lg'
                        : 'border-indigo-100 bg-white/90 text-indigo-700 hover:border-blue-200'
                    }`}
                  >
                    <span className="inline-flex items-center justify-center rounded-2xl bg-white/10 p-2">
                      <tab.icon className={`h-6 w-6 ${isActive ? 'text-white' : 'text-indigo-500'}`} />
                    </span>
                    <span>
                      <span className="block text-sm font-semibold sm:text-base">{tab.label}</span>
                      <span className={`mt-0.5 block text-xs sm:text-sm ${isActive ? 'text-white/80' : 'text-indigo-500/80'}`}>
                        {tab.description}
                      </span>
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="mt-8 rounded-3xl bg-white/90 p-1 shadow-2xl ring-1 ring-indigo-100">
            <div className="rounded-3xl bg-white">
              {tabConfig.component}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
